import { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
  Paper,
  Modal,
  CardContent,
  CardHeader,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tab,
  Tabs,
  Avatar,
  Box,
  Typography,
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import { styled } from "@mui/system";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import LinearProgress from "@material-ui/core/LinearProgress";
import ParamValuesChart from "../view-device/ParamChart";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import { withStyles } from "@material-ui/core";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import Skeleton from "@mui/material/Skeleton";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import breakpoints from "assets/theme/base/breakpoints";
import { renderIcon } from "utils/renderIcon";
import { useMaterialUIController } from "context";
import { setDarkMode } from "context";
import { fieldMapping } from "utils/constant";
import LogsTable from "../view-device/table-view/logsTable";
import EventsTable from "../view-device/table-view/eventsTable";
import { Visibility } from "@mui/icons-material";
import { Edit } from "@mui/icons-material";
import { Delete } from "@mui/icons-material";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    textWrap: "unwrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    height: "auto",
    padding: "6px",
  },
}));

const StackSkeleton = () => {
  return (
    <Stack spacing={0.5}>
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
    </Stack>
  );
};

const PublicLevelMonitor = ({ deviceId }) => {
  const id = deviceId;
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const serviceRequestSelectedTab = localStorage.getItem("serviceRequestTab") ?? 0;

  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [paramValues, setParamValues] = useState([]);
  const [percent, setPercent] = useState(0);
  const [paramValue, setParamValue] = useState();
  const [device, setDevice] = useState();
  const [tableData, setTableData] = useState([]);
  const [deviceStatusName, setDeviceStatusName] = useState("");
  const [expandedIndexArray, setExpandedIndexArray] = useState([
    true,
    true,
    true,
    ...Array(6).fill(false),
  ]);
  const [isShare, setShare] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    parseInt(serviceRequestSelectedTab)
  );

  const [openViewModal, setOpenViewModal] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [alert, setAlert] = useState();
  const [alertTableData, setAlertTableData] = useState([]);

  const [alertRules, setAlertRules] = useState([]);
  const [event, setEvent] = useState([]);
  const [eventTableData, setEventTableData] = useState([]);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [alertRuleTableData, setAlertRuleTableData] = useState([]);
  const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

  const [dataTableUpdate, setDataTableUpdate] = useState("");

  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const [pillbarColor, setPillbarColor] = useState("rgb(38, 40, 51);");
  const [activeAlerts, setActiveAlerts] = useState([]);
  const [loaderT, setLoaderT] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
  const [deviceUpdated, setDeviceUpdated] = useState("");
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [reportType, setReportType] = useState({});

  const [deviceSetupFields, setDeviceSetupFields] = useState({
    depth: "",
    shape: "",
    width: "",
    length: "",
    latitude: "",
    longitude: "",
  });

  const [navbarTitle, setNavbarTitle] = useState("");
  const [titleIcon, setTitleIcon] = useState(null)
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const countRef = useRef(0);

  useEffect(() => {
    if (!deviceId) return;
    setPillbarColor("rgb(38, 40, 51);");
    (async () => {
      try {
        setLoader(true);
        setDarkMode(dispatch, true)

        const res = await CrudService.getPublicDeviceView(deviceId);

        setDevice(res?.data);
        let icons = res?.data?.attributes?.EntityAddressItem?.Icon
        setTitleIcon(icons?.class_name)

        if (res?.data?.reportTypes) {
          let obj = {};
          for (let report of res?.data?.reportTypes) {
            obj[report.report_type_identifier] = report.report_type_name;
          }
          setReportType(obj);
        }

        setName({ text: res.data.attributes?.name });
        setShare(res.data.attributes?.PublicShareDevice?.is_public ?? false);
        let lastRecord;

        setParamValues(res?.data?.monitorParameterValues);
        if (res?.data?.latestWebhookData) {
          // lastRecord = res?.data?.latestWebhookData?.value;
          lastRecord = res?.data?.latestWebhookData?.device_value;
          if (lastRecord?.is_error) {
            lastRecord.device_data.percent_level = '-'
            lastRecord.device_data.product_level = '-'
            lastRecord.device_data.volume_level = '-'
            // lastRecord.data.device_data.percent_level = '-'
            // lastRecord.data.device_data.inch_level = '-'
            // lastRecord.data.device_data.volume_level = '-'
          } else {
            // lastRecord.value.product_level = '-'
            // lastRecord.value.volume_level = '-'
            if (lastRecord && lastRecord?.device_data) {
              lastRecord.device_data.inch_level = `${lastRecord?.device_data?.inch_level ?? 0} Inches`
              lastRecord.device_data.volume_level = `${lastRecord?.device_data?.volume_level ?? 0} Gallons`
            }
          }
          setParamValue(lastRecord);
          // setDeviceStatusName(res?.data?.latestWebhookData?.StatusType?.status_name); // TODO: changes
          setDeviceStatusName(res?.data?.latestWebhookData?.device_value?.status); // TODO: changes
          // setDeviceUpdated(res?.data?.latestWebhookData?.created_at);
          setDeviceUpdated(res?.data?.latestWebhookData?.device_value?.timestamp);
          localStorage.setItem(
            "device_params",
            JSON.stringify(lastRecord)
          );
          setPercent(lastRecord?.device_data?.percent_level || 0);
        } else {
          setLoader(false);
          setNotifyAlert(`There is no logs data available for this device`)
          return
        }
        setLoader(false);

        const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(deviceId);
        let alertData = deviceAlertsRes?.data?.alerts?.reverse()
        setActiveAlerts(alertData);

        // checkActiveServiceRequest();
        if (selectedTab === 4) {
          // serviceRequestList(res?.data?.attributes?.EntityAddressItem?.address_item_id)
        }

        let deviceThresholds = res?.data?.deviceThresholds;
        for (let deviceThreshold of deviceThresholds) {
          if ([1, 26].includes(deviceThreshold.threshold_type_id)) {
            let color = "rgb(38, 40, 51);";
            let comparison_operator_id = deviceThreshold.comparison_operator_id;
            const parameterName =
              deviceThreshold?.DeviceParameter?.parameter_name;

            const parameterMapping = {
              percent_level: "percent_level",
              Temperature: "enclosure_temperature",
              product_level: "inch_level",
              measured_height: "measured_height",
            };

            const propertyKey = parameterMapping[parameterName];
            const parameterValue = parseInt(
              lastRecord?.data?.device_data?.[propertyKey]
            );
            const thresholdValue = parseInt(deviceThreshold.threshold_value);

            if (propertyKey === undefined) {
              console.error(`Unknown parameter name: ${parameterName}`);
              return;
            }

            switch (parseInt(comparison_operator_id)) {
              case 1:
                color =
                  parameterValue === thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 2:
                color =
                  parameterValue !== thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 3:
                color =
                  parameterValue < thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 4:
                color =
                  parameterValue <= thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 5:
                color =
                  parameterValue > thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              case 6:
                color =
                  parameterValue >= thresholdValue
                    ? "#d32f2f"
                    : "rgb(38, 40, 51);";
                break;
              default:
                color = "rgb(38, 40, 51);";
                break;
            }

            setPillbarColor(color);
          }
        }
        if (alertData?.length > 0) {
          setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex)
        }
      } catch (err) {
        if (err.status == 400) {
          navigate('/not-found')
        }
        console.error(err);
      }
    })();
  }, [deviceId, dataTableUpdate]);

  useEffect(() => {
    if (selectedTab == 1) {
      allAlerts(page, rowsPerPage)
    }
    // if (selectedTab === 2) {
    //   allEvents()
    // }
    if (selectedTab === 3) {
      alertRulesList()
    }
    if (selectedTab === 4) {
      serviceRequestList()
    }
  }, [id, selectedTab, page, rowsPerPage, reportType])


  async function allAlerts(page, rowsPerPage) {
    try {
      let resp = await CrudService.getDeviceAlerts(id, page, rowsPerPage);
      let alertFilter = getAlertRows(resp.data);
      setAlertTableData(alertFilter);
      countRef.current = resp?.pagination?.total ?? resp?.count
    } catch (error) {
      console.error('allAlerts', error)
    }
  }

  async function alertRulesList() {
    try {
      const resp = await CrudService.getAlertRules({ id });
      if (resp.data) {
        setAlertRules(resp.data);
        // let rules = getAlertRuleRows(resp.data)
        // setAlertRuleTableData(rules);
      }
    } catch (error) {
      console.error('alertRules', error)
    }
  }

  async function serviceRequestList(address_id = null) {
    // TODO: issue here addrss item id
    let address_item_id = address_id ?? device?.attributes?.EntityAddressItem?.address_item_id;
    if (address_item_id) {
      const resp = await CrudService.getServiceRequests(address_item_id);
      if (resp.data) {
        setServiceRequests(resp.data);
        let requests = getServiceRequestRows(resp.data)
        setServiceRequestTableData(requests);
      }
    }
  }

  useEffect(() => {
    if (alertRules?.length) {
      let rules = getAlertRuleRows(alertRules)
      setAlertRuleTableData(rules);
    }
  }, [alertRules])

  const getAlertRuleRows = (info) => {
    let updatedInfo = info.map((row) => {
      let frequency = "";
      if (row.attributes?.frequency && row.attributes?.frequency != null) {
        frequency =
          row.attributes?.frequency +
          " min" +
          (row.attributes?.frequency > 1 ? "(s)" : "");
      }

      let rule_type =
        row.attributes?.module_id === 12
          ? "Alert"
          : row.attributes?.module_id === 13
            ? "Service Request"
            : "";

      const event_type_id = row.attributes?.event_type_id;
      let message_template_name = "";
      if (event_type_id == 14) {
        message_template_name = row.attributes?.SendgridTemplate?.name;
      }
      if (event_type_id == 15) {
        message_template_name = row.attributes?.MessageTemplate?.name;
      }
      return {
        id: row?.id,
        rule_type: rule_type,
        alert_type: row.attributes?.AlertType?.type_name,
        alert_type_category: row.attributes?.AlertType?.category,
        alert_sub_type: row.attributes?.AlertSubType?.sub_type_name,
        event_type: row.attributes?.EventType?.name,
        message_template_name: message_template_name,
        address: row.attributes?.ContactAddress?.contact_address,
        send_to_type: row.attributes?.SendToType?.send_to_type_name,
        frequency: frequency,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
        status: (
          <Badge
            color={
              row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
            }
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: "30px" }}
          ></Badge>
        ),
      };
    });

    return updatedInfo;
  };

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 100) {
        setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
      } else {
        setNavbarTitle(""); // Remove when scrolled up
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [device?.attributes?.name]);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleClickIPAddress = () => {
    const url = `http://${paramValue.local_ip}`;
    window.open(url, "_blank");
  };

  function capitalizeWords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function formatNumber(input) {
    return parseInt(input);
  }

  function convertDBMforRSRP(value) {
    const regex = /-?\d+(\.\d+)?/;
    value = String(value);
    const match = value.match(regex);

    return formatNumber(match[0]);
  }

  const getRows = (info) => {
    // Sort info array by id in descending order
    info.sort((a, b) => b.id - a.id);
    let updatedInfo = info.map((row, index) => {
      let previousIndex;
      // if (index == 0) {
      //   previousIndex = 0;
      // } else {
      //   previousIndex = index - 1;
      // } 0 0 1 2 3 1 2 3 4 4
      if (info.length - 1 == index) {
        previousIndex = index;
      } else {
        previousIndex = index + 1;
      }
      const value = row.data?.device_data;
      let check_drop = value?.percent_level - info[previousIndex].data?.device_data?.percent_level;
      let percent_level_drop = check_drop < 1 ? check_drop : 0;
      // let percent_level_increase = (info[previousIndex].value?.percent_level - value?.percent_level) - Math.abs(percent_level_drop)
      let percent_level_increase = check_drop > 0 ? check_drop : 0;
      return {
        ...row,
        id: row?.id,
        is_error: row?.data.is_error ? 'Yes' : 'No',
        report_type: row?.data?.reportType
          ? reportType[row?.data?.reportType] ?? ""
          : "",
        battery_status: value?.battery_status,
        battery_voltage: value?.battery_voltage,
        measured_height: value?.measured_height,
        rsrp: convertDBMforRSRP(isNaN(row?.data?.rsrp) ? 0 : row?.data?.rsrp),
        inch_level: row?.data.is_error ? '-' : formatNumber(value?.inch_level),
        percent_level: row?.data.is_error ? '-' : value?.percent_level,
        // percent_level_drop:
        //   info[previousIndex].value?.percent_level - value?.percent_level,
        // percent_level_increase:
        //   value?.percent_level - info[previousIndex].value?.percent_level,
        percent_level_drop: row?.data.is_error ? '-' : percent_level_drop,
        percent_level_increase: row?.data.is_error ? '-' : percent_level_increase,
        previous_percent_level: row?.data.is_error ? '-' : info[previousIndex].data?.device_data?.percent_level,
        volume_level: row?.data.is_error ? '-' : formatNumber(value?.volume_level),
        date: row?.created_at,
        status_text:
          row.data?.status === "Working" ? "Working" : "Not Connected",
        status:
          row.data?.status === "Working" ? (
            <Badge
              variant="gradient"
              badgeContent="Working"
              color="success"
              style={{ marginLeft: "10px" }}
            ></Badge>
          ) : (
            <Badge
              variant="gradient"
              badgeContent="Not Connected"
              color="error"
              style={{ marginLeft: "-90px", width: "120px" }}
            ></Badge>
          ),
      };
    });
    return updatedInfo;
  };

  const dataTableData = {
    columns: [
      { Header: "ID", accessor: "id", show: true },
      { Header: "Is Error", accessor: "is_error", show: paramValue?.isExternal ? true : false },
      {
        Header: "Status Badge",
        accessor: "status",
        show: paramValue?.isExternal ? false : true,
      },
      {
        Header: "Report Type",
        accessor: "report_type",
        width: "20%",
        show: paramValue?.isExternal ? true : false,
      },
      {
        Header: "Battery Status",
        accessor: "battery_status",
        width: "20%",
        show: true,
      },
      {
        Header: "Battery Voltage",
        accessor: "battery_voltage",
        width: "20%",
        show: true,
      },
      {
        Header: "Measured Height",
        accessor: "measured_height",
        width: "20%",
        show: paramValue?.isExternal ? true : false,
      },
      {
        Header: "RSRP",
        accessor: "rsrp",
        width: "5%",
        show: true,
      },
      {
        Header: paramValue?.isExternal ? "Product Level" : "Fluid Level",
        accessor: "inch_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Percent Level",
        accessor: "percent_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Percent Level Drop",
        accessor: "percent_level_drop",
        width: "15%",
      },
      {
        Header: "Percent Level Increase",
        accessor: "percent_level_increase",
        width: "15%",
        show: true,
      },
      {
        Header: "Previous Percent Level",
        accessor: "previous_percent_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Volume Level",
        accessor: "volume_level",
        width: "15%",
        show: true,
      },
      {
        Header: "Date",
        accessor: "date",
        show: true,
        isSortedDesc: true,
        isSorted: true,
        Cell: (info) => {
          return (
            <div
              style={{
                whiteSpace: "normal",
                maxWidth: "300px",
                wordWrap: "break-word",
                wordBreak: "break-word",
              }}
            >
              {moment(info.cell.row.original.date).format(
                "MMMM DD, YYYY h:mm:ss A"
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        show: true,
        isSorted: false,
        Cell: (info) => {
          return (
            <div
              style={{
                padding: '5px'
              }}
            >
              <IconButton onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>
                <Visibility />
              </IconButton>
              {/* <MDButton variant="outlined" color="info" onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>View</MDButton> */}
            </div>
          );
        },
      },
    ],
    rows: tableData, // Assuming tableData is your original data array
  };

  function getMeasuredHeightToolTip() {
    if (paramValue?.device_data?.measured_height === 'Out of Range (Full)') {
      return 'Sensor reading indicates full, but is beyond the expected range. Check for sensor misalignment or obstructions.'
    }
    if (paramValue?.device_data?.measured_height === 'Out of Range (Empty)') {
      return 'Sensor reading indicates empty, but is beyond the expected range. Verify sensor positioning or alignment.'
    }
    return ''
  }

  const alertRuledataTableData = {
    columns: [
      { Header: "ID", accessor: "id", show: true },
      { Header: "Status Badge", accessor: "status", show: true },
      { Header: "Status ", accessor: "status_text", show: false },

      { Header: "Rule Type", accessor: "rule_type", show: true },
      { Header: "Alert Type", accessor: "alert_type", show: true },
      {
        Header: "Alert Type Category",
        accessor: "alert_type_category",
        show: true,
      },
      { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
      { Header: "Event Type", accessor: "event_type", show: true },
      {
        Header: "Message Template Name",
        accessor: "message_template_name",
        show: true,
      },
      { Header: "Address", accessor: "address", show: true },
      { Header: "Send Type", accessor: "send_to_type", show: true },
      { Header: "Frequency", accessor: "frequency", show: true },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        show: true,
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip title="Edit Alert Rule">
                <IconButton
                  onClick={() =>
                    clickAlertRuleEditHandler(info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <Edit />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Alert Rule">
                <IconButton
                  onClick={(e) =>
                    clickAlertRuleDeleteHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <Delete />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            </MDBox>
          );
        },
      },
    ],
    rows: alertRuleTableData, // Assuming tableData is your original data array
  };

  const getEventRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row?.event_id,
        alert_type: row?.AlertType?.type_name,
        parameter_name: row?.DeviceParameter?.parameter_name,
        percent_value: row?.percent_change,
        prev_value: row?.previous_value,
        current_value: row?.new_value,
        volume: row?.volume_change,
        date: row?.event_timestamp,
        raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {}
      };
    });

    return updatedInfo;
  };

  const openJsonTreedata = (e, value) => {
    e.stopPropagation();
    setRawDataValue(value)
    setJsonTree(true)
  }

  const eventdataTableData = {
    columns: [
      {
        Header: "ID",
        accessor: "id",
        show: true,
        Cell: (info) => {
          return <a onClick={(e) => openJsonTreedata(e, info.cell.row.original.raw_data)}>{info.value}</a>
        }
      },
      { Header: "Type", accessor: "alert_type", show: true },
      { Header: "Parameter Name", accessor: "parameter_name", show: true },
      { Header: "Current Value", accessor: "current_value", show: true },
      { Header: "Previous Value", accessor: "prev_value", show: true },
      {
        Header: "Percent Change",
        accessor: "percent_value",
        show: true,
        Cell: (info) => `${Number(info.value).toFixed(0)}%`,
      },
      {
        Header: "Volume Change ( Gallons )",
        accessor: "volume",
        show: true,
        Cell: (info) => `${Number(info.value).toFixed(0)}`,
      },
      {
        Header: "Date",
        accessor: "date",
        show: true,
        isSortedDesc: true,
        isSorted: true,
        Cell: (info) => {
          return (
            <div
              style={{
                whiteSpace: "normal",
                maxWidth: "300px",
                wordWrap: "break-word",
                wordBreak: "break-word",
              }}
            >
              {moment(info.cell.row.original.date).format(
                "MMMM DD, YYYY h:mm:ss A"
              )}
            </div>
          );
        },
      },
    ],
  };

  const getServiceRequestRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.attributes?.service_request_id,
        user: row.attributes?.user?.name,
        entityAddressItem: row.attributes?.EntityAddressItem?.name,
        provider: row.attributes?.Provider?.provider_name,
        serviceItem: row.attributes?.ServiceItem?.item_name,
        request_date: row.attributes?.request_date,
        status: row.attributes?.StatusOption,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
      };
    });

    return updatedInfo;
  };

  const serviceRequestdataTableData = {
    columns: [
      { Header: "ID", accessor: "id", width: "12rem", show: true },
      {
        Header: "Status Badge",
        accessor: "",
        width: "12rem",
        show: true,
        Cell: (info) => {
          return (
            <StyledBadge
              color={
                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
              }
              variant={
                info.cell.row.original?.status?.BadgeDetail?.variant ||
                "contained"
              }
              badgeContent={
                info.cell.row.original.status?.StatusType?.status_name
              }
              style={{ marginLeft: "30px" }}
            ></StyledBadge>
          );
        },
      },
      { Header: "Status", accessor: "status_text", width: "12rem", show: true },

      {
        Header: "Entity Address Item",
        accessor: "entityAddressItem",
        width: "12rem",
        show: true,
      },
      { Header: "Provider", accessor: "provider", width: "12rem", show: true },
      {
        Header: "Service Item",
        accessor: "serviceItem",
        width: "12rem",
        show: true,
      },
      {
        Header: "Requested Date",
        accessor: "request_date",
        width: "12rem",
        show: true,
      },
      { Header: "User", accessor: "user", width: "12rem", show: true },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        width: "12rem",
        show: true,
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip title="View Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestViewHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <SubjectIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Show Status Change Log">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestLogHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <ServiceRequestLogIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestEditHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <EditIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Service Request">
                <IconButton
                  onClick={(e) =>
                    clickServiceRequestDeleteHandler(
                      e,
                      info.cell.row.original.id
                    )
                  }
                >
                  <MDTypography>
                    <DeleteIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            </MDBox>
          );
        },
      },
    ],
    rows: serviceRequestTableData, // Assuming tableData is your original data array
  };

  const getAlertRows = (info) => {
    let updatedInfo = info.map((row) => {
      const createdAt = row.attributes.created_at
        ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
        : "";
      const updatedAt = row.attributes.updated_at
        ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
        : "";
      const subType = row.attributes.is_parent
        ? "Alert Created"
        : row.attributes.is_healed
          ? "Alert Healed"
          : "Alert Resent";

      return {
        id: row.id,
        device_id: row.attributes?.device_id,
        alert_type_id: row.attributes?.alert_type_id,
        alert_type: row.attributes?.AlertType?.type_name,
        alert_type_category: row.attributes?.AlertType?.category,
        device: row.attributes.Device?.name,
        parameter_name: row.attributes?.DeviceParameter?.label ?? '',
        sub_type: subType,
        is_parent: row.attributes?.is_parent,
        threshold_value: row.attributes.threshold,
        exceed_value: row.attributes.exceed_value,
        current_value: row.current_value,
        created_at: createdAt,
        updated_at: updatedAt,
        status_text:
          row.attributes?.StatusOption?.StatusType?.status_name || "",
        status: (
          <Badge
            color={
              row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
            }
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: "30px" }}
          ></Badge>
        ),
      };
    });
    return updatedInfo;
  };

  const clickStatusEdit = (e) => {
    setMultiStatusEditModal(true);
  };

  const alertColumns = [
    { Header: "ID", accessor: "id", width: "5%", show: true },
    { Header: "Status Badge", accessor: "status", width: "5%", show: true },
    { Header: "Status", accessor: "status_text", show: false },
    { Header: "Alert Type", accessor: "alert_type", width: "10%", show: true },
    { Header: 'Parameter', accessor: 'parameter_name', width: '10%', show: true },
    { Header: 'Threshold Value', accessor: 'threshold_value', width: '5%' },
    { Header: 'Exceed Value', accessor: 'exceed_value', width: '5%' },
    { Header: 'Current Value', accessor: 'current_value', width: '5%' },
    {
      Header: "Alert Category",
      accessor: "alert_type_category",
      width: "10%",
      show: true,
    },
    { Header: "Sub Type", accessor: "sub_type", width: "8%", show: true },
    { Header: "Created At", accessor: "created_at", width: "15%", show: true },
    { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
    {
      Header: "actions",
      disableSortBy: true,
      accessor: "actions",
      show: true,
    },
  ];


  const StyledLinearProgress = withStyles({
    root: {
      height: 20, // Increase height of the progress bar here
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 10px", // Add padding for better visibility of percentage
      position: "relative", // Add position relative for absolute positioning of percentage
      borderRadius: "15px",
    },
    bar: {
      borderRadius: "5px",
      backgroundColor: pillbarColor,
    },
  })(LinearProgress);

  const handleExpand = (index) => {
    setExpandedIndexArray((prevArray) =>
      prevArray.map((item, idx) => (idx === index ? !item : item))
    );
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    localStorage.setItem("serviceRequestTab", newValue);
  };

  const renderTableCell = (data) => {
    // If the data is an object (JSON), render each key-value pair
    if (typeof data === "object" && data !== null) {
      return (
        <Table>
          <TableBody>
            {Object.entries(data).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell sx={{ padding: "1px!important;" }}>
                  {formatColumnName(key)}
                </TableCell>
                <TableCell sx={{ padding: "1px!important;" }}>
                  {renderTableCell(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }
    return data;
  };

  const formatColumnName = (name) => {
    return name
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  };

  const DynamicDataTable = (Alert) => {
    // Parse JSON data and extract keys for table columns
    const columns = Object.keys(Alert);

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column}
                  sx={{
                    padding: "0px!important;",
                    color: "#7b809a !important;",
                  }}
                >
                  {formatColumnName(column)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column}>
                  {renderTableCell(Alert[column])}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const cardStyle = (index) => ({
    display: "flex",
    flexDirection: "column",
    ...(expandedIndexArray[index] && { minHeight: "100%" }),
  });

  const styles = {
    table: {
      padding: 0,
      borderSpacing: 0,
      borderCollapse: "collapse",
    },
    cell: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: isTabletOrMobile ? "0" : "15px",
      paddingRight: isTabletOrMobile ? "0" : "15px",
      width: "56%",
    },
    cell1: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: isTabletOrMobile ? "0" : "15px",
      paddingRight: isTabletOrMobile ? "0" : "15px",
      width: isTabletOrMobile ? "135px" : "175px",
    },
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
  };

  const clickViewHandler = async (id, value) => {
    let data = await CrudService.getAlert(id);
    setAlert(data);
    setOpenViewModal(true);
  };

  // This function will handle the removal of the alert when clicked
  const handleClose = async (alertId, alertTypeId, deviceId) => {
    // Filter out the alert with the matching id
    const updatedAlerts = activeAlerts.filter(
      (alert) => alert.alert_id !== alertId
    );
    setActiveAlerts(updatedAlerts);
    const payload = {
      deviceId: deviceId,
      alertTypeId: alertTypeId,
    };
    await CrudService.updateNotificationStatus(payload);
  };

  const checkAllNotification = (alerts) => {
    let isAllNotification = false;
    alerts.forEach((alert) => {
      if (alert?.AlertType?.category != "notice") {
        isAllNotification = true;
        return;
      }
    });
    return isAllNotification;
  };

  const openModalFn = (type) => {
    if (type == "device") {
      setGps({
        latitude: paramValue?.latitude,
        longitude: paramValue?.longitude,
      });
    } else if (type == "item") {
      setGps({
        latitude: deviceSetupFields?.latitude,
        longitude: deviceSetupFields?.longitude,
        edit: true,
      });
    } else if (type == "itemButton") {
      setGps({
        latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
        longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
        edit: true,
      });
    } else {
      setGps({
        latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
        longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
      });
    }
    setOpenModal(true);
  };

  const cond = [null, undefined];

  const RenderTH = ({ value }) => {
    return (
      <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
        <MDTypography fontSize={1}>
          <span style={{ fontWeight: "700" }}>{value}:</span>
        </MDTypography>
      </th>
    );
  };

  const RenderTD = ({ value, style = null, fun = () => { } }) => {
    return (
      <td style={style ?? styles.cell} onClick={fun}>
        <MDTypography fontSize={1}>{value}</MDTypography>
      </td>
    );
  };

  const RenderTR = ({ th, td, tdStyle: customTdStyle, tdFun }) => {
    const mergedTdStyle = {
      ...customTdStyle,
      padding: "0px 15px",
    };

    return (
      <>
        {!["", null, undefined].includes(td) && (
          <>
            <RenderTH value={th} />
            <RenderTD value={td} style={mergedTdStyle} fun={tdFun} />
          </>
        )}
      </>
    );
  };

  const calculateFullDate = (estimatedDays) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + estimatedDays);

    const day = String(currentDate.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const RenderTableRowData = ({ label, value, unit, renderType }) => {
    return (
      <TableRow>
        <TableCell style={styles.cell}>
          <MDTypography fontSize={1}>
            <span style={{ fontWeight: "700" }}>{label}:</span>
          </MDTypography>
        </TableCell>
        <TableCell style={styles.cell}>
          <MDTypography fontSize={1}>
            {renderType === "text" ? (
              typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? (
                new Date(value).toLocaleDateString()
              ) : isNaN(value) ? (
                value
              ) : (
                `${Math.trunc(value)}${unit ? unit : ""}`
              )
            ) : renderType === "icon" ? (
              <Box display="flex" alignItems="center">
                <span>{value}</span>
                &nbsp;
                {renderIcon(label, value)}
              </Box>
            ) : (
              <Box display="flex" alignItems="center">
                <span>{value}</span>
                {renderIcon(label, value)}
              </Box>
            )}
          </MDTypography>
        </TableCell>
      </TableRow>
    );
  };

  function fetchDeviceSettingData() {

    let showData = [];
    let ignore = ['hexjson', 'server1', 'server2', 'id']
    for (const [key, value] of Object.entries(paramValue?.device_setup_details)) {
      if (ignore.includes(key)) {
        continue;
      }
      showData.push({
        label: key.split(' ').map((e) => e[0].toUpperCase() + e.slice(1)).join(" "),
        value: value,
        unit: '',
        renderType: 'text'
      })
    }
    return showData;
  }

  const TableSection = ({ title, rowData }) => (
    <Box sx={{ marginBottom: 2 }}>
      <MDTypography fontSize={1}>
        <span style={{ fontWeight: "700" }}>{title}</span>
      </MDTypography>
      <Table
        style={{
          ...styles.table,
          marginTop: "5px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <TableBody>
          {rowData.map((row, idx) => (
            <RenderTableRowData key={idx} {...row} />
          ))}
        </TableBody>
      </Table>
    </Box>
  );

  return (
    <div style={{ width: '100%', height: '100vh', padding: '0 1rem' }}>
      <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} showBreadCrumbs={false} />

      <MDBox mt={0} mb={9}>
        <Grid justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={0} mb={0} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  {titleIcon ? <i className={titleIcon} style={{ fontSize: "24px" }}></i> : ''} {device?.attributes?.name}{" "}
                  {activeAlerts.length != 0 &&
                    checkAllNotification(activeAlerts) ? (
                    <i
                      className="fas fa-triangle-exclamation"
                      style={{ fontSize: "24px", color: "#d32f2f" }}
                    ></i>
                  ) : (
                    ""
                  )}
                </MDTypography>
                {activeAlerts.map((alert) => (
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      padding: "5px",
                      marginBottom: "10px",
                      border: `1px solid ${
                        // alert?.AlertType?.alert_type_id === 11 ||
                        // alert?.AlertType?.alert_type_id === 12
                        alert?.AlertType?.category == "notice"
                          ? "green"
                          : "#d32f2f"
                        }`,
                      alignItems: "center",
                      backgroundColor:
                        alert?.AlertType?.category == "notice"
                          ? "#d1ffd6"
                          : "#ffcccb",
                    }}
                  >
                    {/* Close button */}
                    {alert?.AlertType?.category == "notice" && (
                      <button
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "transparent",
                          border: "none",
                          fontSize: "16px",
                          cursor: "pointer",
                          color: "black",
                        }}
                        onClick={() =>
                          handleClose(
                            alert?.alert_id,
                            alert?.alert_type_id,
                            alert?.device_id
                          )
                        } // Replace with your close function
                      >
                        &times;
                      </button>
                    )}
                    <MDTypography
                      variant="h6"
                      style={{
                        fontSize: "12px",
                        color:
                          alert?.AlertType?.category == "notice"
                            ? "green"
                            : "#d32f2f",
                        marginLeft: "10px",
                      }}
                    >
                      <i
                        className={alert?.AlertType?.Icon?.class_name}
                        style={{
                          marginRight: "5px",
                          fontSize: "16px",
                          color:
                            alert?.AlertType?.category == "notice"
                              ? "green"
                              : "#d32f2f",
                        }}
                      ></i>{" "}
                      {alert?.AlertType?.type_name} -{" "}
                      {alert?.AlertType?.description} &middot;{" "}
                      {moment(alert?.created_at).format(
                        "MMMM Do YYYY, h:mm:ss A"
                      )}
                    </MDTypography>
                  </div>
                ))}
              </MDBox>
            </MDBox>
            <Card>
              <MDBox>
                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                  <MDBox>
                    <MDTypography>Level</MDTypography>
                    <MDBox style={{ position: "relative" }}>
                      <StyledLinearProgress
                        variant="determinate"
                        value={percent}
                      />
                      <MDBox
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        color={percent == '-' ? "white" : percent > 49 ? "white" : "black"}
                      >
                        <MDTypography variant="body2" color="textSecondary">
                          {percent == '-' ? percent : `${percent}%`}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <ParamValuesChart paramValues={paramValues} />
                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        {
                          title: "Device Information",
                          icon: "fas fa-info-circle",
                        },
                        { title: "Current Data", icon: "fas fa-chart-line" },
                        { title: "Monitor", icon: "fas fa-tachometer-alt" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index}>
                          <Card style={cardStyle(index)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index)}
                            />
                            {expandedIndexArray[index] && (
                              <CardContent
                                style={
                                  isTabletOrMobile
                                    ? { padding: "16px", flex: 1 }
                                    : { flex: 1 }
                                }
                              >
                                {index === 0 && (
                                  <>

                                    {!loader ? (
                                      <Table
                                        style={{
                                          ...styles.table,
                                          marginTop: "5px",
                                          boxShadow:
                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                      >
                                        <TableBody>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Device Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {name?.text}
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Device Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes?.DeviceType
                                                    ?.type_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Brand:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.DeviceBrand?.brand_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Model:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.DeviceModel?.model_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Item
                                                    ?.ItemType?.type_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>
                                                  Entity Address Id:
                                                </strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.address_id
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Item Type:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Item
                                                    ?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Address Name:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Address:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {[
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.street_address1,
                                                  device?.attributes
                                                    ?.EntityAddressItem?.Address
                                                    ?.street_address2,
                                                  [
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.city,
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.state,
                                                    device?.attributes
                                                      ?.EntityAddressItem
                                                      ?.Address?.postal_code,
                                                  ]
                                                    .filter(Boolean)
                                                    .join(", "),
                                                ]
                                                  .filter(Boolean)
                                                  .join(", ")}
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                <strong>Status / Mode:</strong>
                                              </MDTypography>
                                            </TableCell>
                                            <TableCell style={styles.cell}>
                                              <MDTypography fontSize={1}>
                                                {
                                                  device?.attributes
                                                    ?.StatusOption?.StatusType
                                                    ?.status_name
                                                } / {
                                                  device?.attributes?.DeviceMode?.mode_name
                                                }
                                              </MDTypography>
                                            </TableCell>
                                          </TableRow>
                                          {deviceSetupFields?.latitude && (
                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Item Latitude:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  ...styles.cell,
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  openModalFn("item")
                                                }
                                              >
                                                <MDTypography fontSize={1}>
                                                  <a>
                                                    {
                                                      deviceSetupFields?.latitude
                                                    }
                                                  </a>
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                          {deviceSetupFields?.longitude && (
                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Item Longitude:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  ...styles.cell,
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  openModalFn("item")
                                                }
                                              >
                                                <MDTypography fontSize={1}>
                                                  <a>
                                                    {
                                                      deviceSetupFields?.longitude
                                                    }
                                                  </a>
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </TableBody>
                                      </Table>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    {loader && <StackSkeleton />}

                                    <Table
                                      style={{
                                        ...styles.table,
                                        marginTop: "5px",
                                        boxShadow:
                                          "0 2px 4px rgba(0, 0, 0, 0.1)",
                                      }}
                                    >
                                      <TableBody>
                                        {!loader && (
                                          <>
                                            {paramValue?.isExternal &&
                                              !cond.includes(
                                                paramValue?.device_data
                                                  ?.measured_height
                                              ) && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                    title={getMeasuredHeightToolTip()}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Measured Height:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                    title={getMeasuredHeightToolTip()}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {typeof paramValue
                                                        ?.device_data
                                                        ?.measured_height ===
                                                        "number"
                                                        ? `${paramValue?.device_data?.measured_height} Inches`
                                                        : paramValue
                                                          ?.device_data
                                                          ?.measured_height}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            {!cond.includes(
                                              paramValue?.device_data
                                                ?.inch_level
                                            ) && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        {paramValue?.isExternal
                                                          ? "Product Level"
                                                          : "Fluid Level"}
                                                        :
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography
                                                      fontSize={1}
                                                    >{`${String(
                                                      paramValue?.device_data
                                                        ?.inch_level
                                                    )}`}</MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Percent Level:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  {
                                                    paramValue?.device_data
                                                      ?.percent_level
                                                  }
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>
                                            {!cond.includes(
                                              paramValue?.device_data
                                                ?.volume_level
                                            ) && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Volume Level:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography
                                                      fontSize={1}
                                                    >{`${paramValue?.device_data?.volume_level}`}</MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            {!cond.includes(
                                              paramValue?.device_data
                                                ?.enclosure_temperature
                                            ) && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Temperature:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography
                                                      fontSize={1}
                                                    >{`${paramValue?.device_data
                                                      ?.enclosure_temperature
                                                      } ${paramValue?.temperature_units ??
                                                      ""
                                                      }`}</MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}

                                            <TableRow>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  <strong>
                                                    Battery Voltage:
                                                  </strong>
                                                </MDTypography>
                                              </TableCell>
                                              <TableCell style={styles.cell}>
                                                <MDTypography fontSize={1}>
                                                  {
                                                    paramValue?.device_data
                                                      ?.battery_voltage
                                                  }
                                                </MDTypography>
                                              </TableCell>
                                            </TableRow>

                                            {paramValue?.device_data
                                              ?.battery_status && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Battery Status:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell style={styles.cell}>
                                                    {paramValue?.device_data
                                                      ?.battery_status ===
                                                      "Good" ? (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent="Good"
                                                        color="success"
                                                        style={{
                                                          marginLeft: "30px",
                                                        }}
                                                      ></Badge>
                                                    ) : (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent="Not Good"
                                                        color="error"
                                                        style={{
                                                          marginLeft: "-60px",
                                                          width: "100px",
                                                        }}
                                                      ></Badge>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              )}

                                            {device?.attributes
                                              ?.EntityAddressItem?.Address
                                              ?.latitude && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Address Latitude:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      ...styles.cell,
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      openModalFn("address")
                                                    }
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <a>
                                                        {
                                                          device?.attributes
                                                            ?.EntityAddressItem
                                                            ?.Address?.latitude
                                                        }
                                                      </a>
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            {device?.attributes
                                              ?.EntityAddressItem?.Address
                                              ?.longitude && (
                                                <TableRow>
                                                  <TableCell style={styles.cell}>
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Address Longitude:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      ...styles.cell,
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      openModalFn("address")
                                                    }
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <a>
                                                        {
                                                          device?.attributes
                                                            ?.EntityAddressItem
                                                            ?.Address?.longitude
                                                        }
                                                      </a>
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            {paramValue?.isExternal && (
                                              <>
                                                {paramValue?.latitude &&
                                                  paramValue?.latitude !=
                                                  0 && (
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <strong>
                                                            Device Latitude:
                                                          </strong>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={{
                                                          ...styles.cell,
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openModalFn("device")
                                                        }
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <a>
                                                            {Number(
                                                              paramValue?.latitude
                                                            ).toFixed(8)}
                                                          </a>
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {paramValue?.longitude &&
                                                  paramValue?.longitude !=
                                                  0 && (
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <strong>
                                                            Device Longitude:
                                                          </strong>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={{
                                                          ...styles.cell,
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openModalFn("device")
                                                        }
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <a>
                                                            {Number(
                                                              paramValue?.longitude
                                                            ).toFixed(8)}
                                                          </a>
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                                {paramValue?.longitude != 0 &&
                                                  paramValue?.latitude != 0 &&
                                                  paramValue?.last_device_updated && (
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <strong>
                                                            Last Updated:
                                                          </strong>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {moment(
                                                            paramValue?.last_device_updated
                                                          ).format(
                                                            "MMMM Do YYYY, h:mm:ss a"
                                                          )}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                  )}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </>
                                )}
                                {index === 2 && (
                                  <>
                                    {loader && <StackSkeleton />}
                                    {!loader && (
                                      <MDBox>
                                        <table className="table table-borderless">
                                          <tbody>
                                            <tr>
                                              <RenderTR
                                                th={"Name"}
                                                td={device?.monitor}
                                              />
                                            </tr>
                                            <tr>
                                              {device?.monitor_status
                                                ?.StatusType?.status_name && (
                                                  <RenderTR
                                                    th={"Status"}
                                                    td={
                                                      <Badge
                                                        color={
                                                          device?.monitor_status
                                                            ?.BadgeDetail
                                                            ?.color || "primary"
                                                        }
                                                        variant={
                                                          device?.monitor_status
                                                            ?.BadgeDetail?.variant
                                                        }
                                                        badgeContent={
                                                          device?.monitor_status
                                                            ?.StatusType
                                                            ?.status_name
                                                        }
                                                        style={{
                                                          marginLeft: "30px",
                                                        }}
                                                      ></Badge>
                                                    }
                                                  />
                                                )}
                                            </tr>
                                            <tr>
                                              {device?.monitor_frequency && (
                                                <RenderTR
                                                  th={"Frequency"}
                                                  td={`${device?.monitor_frequency ??
                                                    ""
                                                    } ${device?.monitor_time_unit ??
                                                    ""
                                                    }`}
                                                />
                                              )}
                                            </tr>
                                            <tr>
                                              {device?.monitor_last_updated && (
                                                <RenderTR
                                                  th={"Last Updated"}
                                                  td={moment(
                                                    device?.monitor_last_updated
                                                  ).format(
                                                    "MMMM Do YYYY, h:mm:ss a"
                                                  )}
                                                />
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>

                                        {device?.deviceThresholds.map(
                                          (threshold, thresholdIndex) => (
                                            <Table
                                              key={thresholdIndex + 3}
                                              style={{
                                                ...styles.table,
                                                marginTop: "5px",
                                                boxShadow:
                                                  "0 2px 4px rgba(0, 0, 0, 0.1)",
                                              }}
                                            >
                                              <TableBody>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Alert Type:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold?.AlertType
                                                          ?.type_name
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Parameter
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold
                                                          ?.DeviceParameter
                                                          ?.label
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Comparison Operator:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold
                                                          ?.ComparisonOperator
                                                          ?.label
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        {" "}
                                                        Threshold Comparison
                                                        Value:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        threshold?.threshold_value
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          )
                                        )}
                                      </MDBox>
                                    )}
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>

                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        { title: "Transmission", icon: "fas fa-signal" },
                        { title: "Analytics", icon: "fas fa-chart-diagram" },
                        { title: "Providers", icon: "fas fa-truck" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index + 3}>
                          <Card style={cardStyle(index + 3)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index + 3)}
                            />
                            {expandedIndexArray[index + 3] && (
                              <CardContent style={{ flex: 1 }}>
                                {index === 0 && (
                                  <>
                                    {!loader ? (
                                      <Table
                                        style={{
                                          ...styles.table,
                                          marginTop: "5px",
                                          boxShadow:
                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                      >
                                        <TableBody>
                                          {!loader && (
                                            <>
                                              {deviceStatusName && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>Status:</strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    {deviceStatusName ===
                                                      "Working" ? (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent={
                                                          deviceStatusName
                                                        }
                                                        color="success"
                                                        style={{
                                                          marginLeft: "40px",
                                                        }}
                                                      ></Badge>
                                                    ) : deviceStatusName !==
                                                      "" ? (
                                                      <Badge
                                                        variant="gradient"
                                                        badgeContent={
                                                          deviceStatusName
                                                        }
                                                        color="error"
                                                        style={{
                                                          marginLeft: "-60px",
                                                          width: "120px",
                                                        }}
                                                      ></Badge>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {![null, undefined].includes(
                                                paramValue?.tx_signal
                                              ) && (
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        <strong>
                                                          Signal Strength:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        {paramValue?.isExternal
                                                          ? paramValue?.tx_signal
                                                            ? `${(paramValue?.tx_signal).toFixed(
                                                              2
                                                            )}dBm`
                                                            : ""
                                                          : paramValue?.tx_signal}
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              <TableRow>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    <strong>
                                                      WiFi Signal:
                                                    </strong>
                                                  </MDTypography>
                                                </TableCell>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    {paramValue?.wifi_signal}
                                                  </MDTypography>
                                                </TableCell>
                                              </TableRow>
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.tx_reported) && (
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        <strong>Reported:</strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        {paramValue?.isExternal
                                                          ? moment(
                                                            paramValue?.timestamp ??
                                                            deviceUpdated
                                                          ).format(
                                                            "MMM Do YYYY, h:mm A"
                                                          )
                                                          : paramValue?.tx_reported}
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.reported) && (
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        <strong>
                                                          Last Reported:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        {paramValue?.isExternal
                                                          ? moment(
                                                            paramValue?.timestamp ??
                                                            deviceUpdated
                                                          ).format(
                                                            "MMM Do YYYY, h:mm A"
                                                          )
                                                          : paramValue?.reported}
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              {(paramValue?.timestamp ||
                                                deviceUpdated ||
                                                paramValue?.reported) && (
                                                  <TableRow>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        <strong>
                                                          Last Updated:
                                                        </strong>
                                                      </MDTypography>
                                                    </TableCell>
                                                    <TableCell
                                                      style={styles.cell}
                                                    >
                                                      <MDTypography fontSize={1}>
                                                        {paramValue?.isExternal
                                                          ? moment(
                                                            paramValue?.timestamp ??
                                                            deviceUpdated
                                                          ).fromNow()
                                                          : moment(
                                                            paramValue?.reported,
                                                            "MMM Do, h:mm A"
                                                          ).fromNow()}
                                                      </MDTypography>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              <TableRow>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    <strong>
                                                      Last Updated on:
                                                    </strong>
                                                  </MDTypography>
                                                </TableCell>
                                                <TableCell style={styles.cell}>
                                                  <MDTypography fontSize={1}>
                                                    {
                                                      paramValue?.last_updated_on
                                                    }
                                                  </MDTypography>
                                                </TableCell>
                                              </TableRow>
                                              {paramValue?.local_ip && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        IP Address:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                          color: "blue",
                                                        }}
                                                        onClick={
                                                          handleClickIPAddress
                                                        }
                                                      >
                                                        {paramValue?.local_ip}
                                                      </a>
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.reportType && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Report Type:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {
                                                        reportType[
                                                        paramValue?.reportType
                                                        ]
                                                      }
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.frameCount && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Frame Count:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      {paramValue?.frameCount}
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              {paramValue?.is_error && (
                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <strong>
                                                        Is Error:
                                                      </strong>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      Yes
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            </>
                                          )}
                                        </TableBody>
                                      </Table>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    {!loader ? (
                                      <>
                                        {/* Last 24h Section */}
                                        <Box sx={{ marginBottom: 2 }}>
                                          <TableSection
                                            title="Last 24 Hours"
                                            rowData={[
                                              {
                                                label: "Percent Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.percent_change,
                                                unit: "%",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Level Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.inch_change,
                                                unit: " inches",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Volume Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.last_24_hours
                                                    ?.volume_change,
                                                unit: " gal",
                                                renderType: "text",
                                              },
                                            ]}
                                          />
                                        </Box>

                                        {/* Last 7 Days Section */}
                                        <Box sx={{ marginBottom: 2 }}>
                                          <TableSection
                                            title="Last 7 Days"
                                            rowData={[
                                              {
                                                label: "Percent Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days
                                                    ?.percent_change,
                                                unit: "%",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Level Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days?.inch_change,
                                                unit: " inches",
                                                renderType: "text",
                                              },
                                              {
                                                label: "Volume Change",
                                                value:
                                                  device?.device_analytics
                                                    ?.past_7_days
                                                    ?.volume_change,
                                                unit: " gal",
                                                renderType: "text",
                                              },
                                            ]}
                                          />
                                        </Box>

                                        {/* AI Analysis Section */}
                                        {device?.analysis && (
                                          <Box sx={{ marginBottom: 2 }}>
                                            <TableSection
                                              title="AI Analysis"
                                              // rowData={Object.entries(device.analysis).map(([label, value]) => ({
                                              //   label,
                                              //   value,
                                              //   renderType:
                                              //     label === "Trend" || label === "Status" || label === "Anomalies" ? "icon" : "text",
                                              // }))}
                                              rowData={[
                                                {
                                                  label: "Trend",
                                                  value:
                                                    device?.analysis?.Trend,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label: "Status",
                                                  value:
                                                    device?.analysis?.Status,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label: `${capitalizeWords(
                                                    device?.analysis[
                                                    "Estimated Type"
                                                    ] || ""
                                                  )} Date`,
                                                  value: ![
                                                    0,
                                                    null,
                                                    undefined,
                                                    "",
                                                  ].includes(
                                                    device?.analysis?.[
                                                    "Estimated Time (Days)"
                                                    ]
                                                  )
                                                    ? calculateFullDate(
                                                      device.analysis[
                                                      "Estimated Time (Days)"
                                                      ]
                                                    )
                                                    : "None",
                                                  renderType: "text",
                                                },
                                                {
                                                  label: `Days Until ${capitalizeWords(
                                                    device?.analysis[
                                                    "Estimated Type"
                                                    ] || ""
                                                  )}`,
                                                  value:
                                                    device?.analysis?.[
                                                    "Estimated Time (Days)"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Estimated Type",
                                                  value:
                                                    device?.analysis?.[
                                                    "Estimated Type"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Anomalies",
                                                  value:
                                                    device?.analysis?.Anomalies,
                                                  renderType: "icon",
                                                },
                                                {
                                                  label:
                                                    "Threshold Breach Prediction",
                                                  value:
                                                    device?.analysis?.[
                                                    "Threshold Breach Prediction"
                                                    ],
                                                  renderType: "text",
                                                },
                                                {
                                                  label: "Reason",
                                                  value:
                                                    device?.analysis?.[
                                                    "Reason"
                                                    ],
                                                  renderType: "text",
                                                },
                                              ]}
                                            />
                                          </Box>
                                        )}
                                      </>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}

                                {index === 2 && (
                                  <>
                                    <MDBox>
                                      <Grid
                                        container
                                        justifyContent="space-between"
                                      >
                                        <Grid item>
                                          <MDTypography variant="h6">
                                            Provider
                                          </MDTypography>
                                        </Grid>
                                        <Grid item>
                                          <MDTypography variant="h6" mr={3}>
                                            Share
                                          </MDTypography>
                                        </Grid>
                                      </Grid>
                                      {!loader ? (
                                        <>
                                          {device?.entityAddressItemProviders.map(
                                            (provider) => (
                                              <MDBox
                                                key={provider?.association_id}
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent:
                                                    "space-between",
                                                  width: "100%",
                                                }}
                                              >
                                                <MDBox
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Avatar
                                                    src={
                                                      provider?.Provider
                                                        ?.logo_url
                                                    }
                                                    alt={
                                                      provider?.Provider
                                                        ?.provider_name
                                                    }
                                                    sx={{
                                                      width: 60,
                                                      height: 60,
                                                    }}
                                                  />
                                                  <MDTypography ml={2}>
                                                    {
                                                      provider?.Provider
                                                        ?.provider_name
                                                    }
                                                  </MDTypography>
                                                </MDBox>
                                              </MDBox>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <StackSkeleton />
                                      )}
                                    </MDBox>
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>

                  <MDBox mb={3}>
                    <Grid container spacing={3}>
                      {[
                        {
                          title: "Contact Detail",
                          icon: "fas fa-address-book",
                        },
                        {
                          title: "Device Setup",
                          icon: "fas fa-wrench",
                        },
                        { title: "Actions", icon: "fas fa-cogs" },
                      ].map((item, index) => (
                        <Grid item xs={12} lg={4} key={index + 6}>
                          <Card style={cardStyle(index + 6)}>
                            <CardHeader
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <i
                                    className={item.icon}
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  {item.title}
                                </div>
                              }
                              style={{
                                // backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #e0e0e0",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand(index + 6)}
                            />
                            {expandedIndexArray[index + 6] && (
                              <CardContent
                                style={{
                                  flex: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {index === 0 && (
                                  <>
                                    {!loader ? (
                                      <>
                                        {device &&
                                          device.contacts &&
                                          device.contacts.map(
                                            (contact, contactindex) => (
                                              <MDBox key={contactindex + 6}>
                                                <Table
                                                  style={{
                                                    ...styles.table,
                                                    marginTop: "5px",
                                                    boxShadow:
                                                      "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                  }}
                                                >
                                                  <TableBody>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Contact Name:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Access Type:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {
                                                            contact?.access_type?.toUpperCase()
                                                          }
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {" "}
                                                            Status:{" "}
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography
                                                          fontSize={1}
                                                        >
                                                          {
                                                            contact?.Contact
                                                              ?.StatusOption
                                                              ?.StatusType
                                                              ?.status_name
                                                          }
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    {contact?.Contact
                                                      ?.ContactAddresses &&
                                                      contact?.Contact?.ContactAddresses.map(
                                                        (address, subindex) => (
                                                          <TableRow
                                                            key={subindex + 6}
                                                          >
                                                            <TableCell
                                                              style={
                                                                styles.cell
                                                              }
                                                            >
                                                              <MDTypography
                                                                fontSize={1}
                                                              >
                                                                <span
                                                                  style={{
                                                                    fontWeight:
                                                                      "700",
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  {
                                                                    address
                                                                      ?.ContactAddressType
                                                                      ?.type_name
                                                                  }
                                                                  :{" "}
                                                                </span>
                                                              </MDTypography>
                                                            </TableCell>
                                                            <TableCell
                                                              style={
                                                                styles.cell
                                                              }
                                                            >
                                                              <MDTypography
                                                                fontSize={1}
                                                              >
                                                                {
                                                                  address?.contact_address
                                                                }
                                                              </MDTypography>
                                                            </TableCell>
                                                          </TableRow>
                                                        )
                                                      )}
                                                  </TableBody>
                                                </Table>
                                              </MDBox>
                                            )
                                          )}
                                      </>
                                    ) : (
                                      <StackSkeleton />
                                    )}
                                  </>
                                )}
                                {index === 1 && (
                                  <>
                                    <MDBox>
                                      {!loader ? (
                                        <Box sx={{ marginBottom: 2 }}>
                                          <Box sx={{ marginBottom: 2 }}>
                                            <Table
                                              style={{
                                                ...styles.table,
                                                marginTop: "5px",
                                                boxShadow:
                                                  "0 2px 4px rgba(0, 0, 0, 0.1)",
                                              }}
                                            >
                                              <MDTypography fontSize={1}>
                                                <span style={{ fontWeight: "700" }}>Device Item</span>
                                              </MDTypography>
                                              <TableBody>
                                                {/* Render Device Setup Fields */}
                                                {[
                                                  {
                                                    label: "Depth",
                                                    value: deviceSetupFields?.depth,
                                                  },
                                                  {
                                                    label: "Shape",
                                                    value: deviceSetupFields?.shape,
                                                  },
                                                  {
                                                    label: "Width",
                                                    value: deviceSetupFields?.width,
                                                  },
                                                  {
                                                    label: "Length",
                                                    value:
                                                      deviceSetupFields?.length,
                                                  },
                                                ].map(
                                                  (field, index) =>
                                                    field.value && (
                                                      <TableRow
                                                        key={`setup-${index}`}
                                                      >
                                                        <TableCell
                                                          style={styles.cell}
                                                        >
                                                          <MDTypography
                                                            fontSize={1}
                                                          >
                                                            <span
                                                              style={{
                                                                fontWeight: "700",
                                                              }}
                                                            >
                                                              {field.label}:
                                                            </span>
                                                          </MDTypography>
                                                        </TableCell>
                                                        <TableCell
                                                          style={styles.cell}
                                                        >
                                                          <MDTypography
                                                            fontSize={1}
                                                          >
                                                            {field.value}
                                                          </MDTypography>
                                                        </TableCell>
                                                      </TableRow>
                                                    )
                                                )}

                                                {/* Render Device Identifier Values */}
                                                {device.attributes?.DeviceIdentifierValues?.map(
                                                  (e, i) => (
                                                    <TableRow
                                                      key={`identifier-${i}`}
                                                    >
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography fontSize={1}>
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            {
                                                              e.DeviceIdentifierType
                                                                .identifier_type_name
                                                            }
                                                            :
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography fontSize={1}>
                                                          {e.value}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                  )
                                                )}

                                                <TableRow>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                      <span
                                                        style={{
                                                          fontWeight: "700",
                                                        }}
                                                      >
                                                        Public Share Device:
                                                      </span>
                                                    </MDTypography>
                                                  </TableCell>
                                                  <TableCell
                                                    style={styles.cell}
                                                  >
                                                    <MDTypography fontSize={1}>
                                                    </MDTypography>
                                                  </TableCell>
                                                </TableRow>
                                                {
                                                  isShare ?
                                                    <TableRow>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography fontSize={1}>
                                                          <span
                                                            style={{
                                                              fontWeight: "700",
                                                            }}
                                                          >
                                                            Public Share Device URL:
                                                          </span>
                                                        </MDTypography>
                                                      </TableCell>
                                                      <TableCell
                                                        style={styles.cell}
                                                      >
                                                        <MDTypography fontSize={1}>
                                                          {`${location.origin}/device/public/${device.attributes?.PublicShareDevice?.public_uuid}`}
                                                        </MDTypography>
                                                      </TableCell>
                                                    </TableRow>
                                                    : <></>
                                                }

                                              </TableBody>
                                            </Table>
                                          </Box>
                                          {
                                            paramValue?.device_setup_details ?
                                              <TableSection title={'Device Setting'}
                                                rowData={fetchDeviceSettingData()}
                                              />
                                              : ''
                                          }
                                        </Box>
                                      ) : (
                                        <StackSkeleton />
                                      )}
                                    </MDBox>
                                  </>
                                )}
                                {index === 2 && (
                                  <>
                                  </>
                                )}
                              </CardContent>
                            )}
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>
                  <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <MDBox tabIndex={-1}>
                      <GoogleMapComponent
                        lat={gps.latitude}
                        lng={gps.longitude}
                      />
                    </MDBox>
                  </Modal>

                  <Grid item xs={12} sm={8} lg={4}>
                    <Tabs
                      value={selectedTab}
                      orientation={tabsOrientation}
                      onChange={handleTabChange}
                      aria-label="Tabs"
                      sx={{ display: "flex" }}
                    >
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-file-alt"
                              style={{ marginRight: "2px" }}
                            ></i>
                            Logs
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-exclamation-triangle"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Alerts
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fa-solid fa-clock"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Events
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1", p: "1" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              p: "2",
                              alignItems: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "2px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-code-branch"
                              style={{ marginRight: "1px" }}
                            ></i>
                            Rules
                          </Box>
                        }
                      />
                      <Tab
                        sx={{ flex: "1.5", p: "2" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: { xs: "0.85rem", sm: "1rem" },
                              gap: { xs: "0px", sm: "8px" },
                            }}
                          >
                            <i
                              className="fas fa-tools"
                              style={{ marginRight: "0px" }}
                            ></i>
                            <Typography
                              sx={{ fontSize: { xs: "0.825rem", sm: "1rem" } }}
                            >
                              Service Request
                            </Typography>
                          </Box>
                        }
                      />
                    </Tabs>
                  </Grid>

                  {selectedTab === 0 && (
                    <LogsTable
                      columns={dataTableData.columns}
                      id={id}
                      getRows={getRows}
                      canSearch={true}
                      canDelete={false}
                      canExport={false}
                      isSelection={false}
                    />
                  )}
                  {selectedTab === 1 && (
                    <>
                      <Modal
                        open={openViewModal}
                        onClose={handleViewClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                      >
                        <Card
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "80%", // Set the desired width here
                            backgroundColor: "white",
                            boxShadow: 24,
                            p: 4,
                            maxHeight: "70vh", // Set max height to enable scrolling
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <CardContent>
                            <DynamicDataTable Alert={alert} />
                          </CardContent>
                        </Card>
                      </Modal>

                      <MDBox pt={6} pb={3}>
                        <MDBox mb={3}>
                          <CollapsibleTable
                            width="100%"
                            data={alertTableData}
                            columns={alertColumns}
                            clickViewHandler={clickViewHandler}
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                            count={countRef.current}
                          />
                        </MDBox>
                      </MDBox>
                    </>
                  )}
                  {selectedTab === 2 && (
                    <>
                      <EventsTable
                        columns={eventdataTableData.columns}
                        id={id}
                        getRows={getEventRows}
                        canSearch={true}
                        canDelete={false}
                        isSelection={false}
                      />
                    </>
                  )}
                  {selectedTab === 3 && (
                    <>
                      <DataTable
                        table={alertRuledataTableData}
                        canSearch={true}
                      />
                    </>
                  )}
                  {selectedTab === 4 && (
                    <MDBox sx={{ marginTop: "20px" }}>
                      {/* <Can I="view" this={"phone"}>
                        <MDBox>
                          <MDButton
                            variant={"gradient"}
                            color="primary"
                            size="small"
                            px={2}
                            my={2}
                            mx={2}
                            onClick={() => setPhoneEnvModal(true)}
                          >
                            Open Phone
                          </MDButton>
                        </MDBox>
                      </Can> */}

                      <ServiceRequestDataTable
                        table={serviceRequestdataTableData}
                        canSearch={true}
                        setDataTableUpdate={setDataTableUpdate}
                      />
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </div>
  );
};

export default PublicLevelMonitor;
